export type User = {
	username?: string;
	firstName?: string | null;
	lastName?: string | null;
};
